import { css } from '@emotion/css';

export const editorStyles = css`
  min-height: 18.8rem;
  max-height: 27.4rem;
`;
